import { render, staticRenderFns } from "./eightConsumerList.vue?vue&type=template&id=caaee6f2&scoped=true"
import script from "./eightConsumerList.vue?vue&type=script&lang=js"
export * from "./eightConsumerList.vue?vue&type=script&lang=js"
import style0 from "./eightConsumerList.vue?vue&type=style&index=0&id=caaee6f2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caaee6f2",
  null
  
)

export default component.exports